export default "__VITE_ASSET__93f4a7d7__"